<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="1">
        <div class="tab-card" :class="isDetail ? 'no-events' : ''">
          <default-info ref="defaultInfo"></default-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="类目属性" name="2">
        <div class="tab-card" :class="isDetail ? 'no-events' : ''">
          <category-info ref="categoryInfo"></category-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="备件相册" name="3">
        <div class="tab-card" :class="isDetail ? 'no-events' : ''">
          <album-info ref="albumInfo"></album-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="图文描述" name="4">
        <div class="tab-card" :class="isDetail ? 'no-events' : ''">
          <img-info ref="imgInfo"></img-info>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="btns">
      <el-button class="btn" @click="clickCancel">取消</el-button>
      <el-button type="primary" v-show="!isDetail" class="btn" @click="clickSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import defaultInfo from './components/defaultInfo'
import categoryInfo from './components/categoryInfo'
import albumInfo from './components/albumInfo'
import imgInfo from './components/imgInfo'
export default {
  name: 'sharedSparePartsAdd', // 备件发布新增
  components: {
    defaultInfo,
    categoryInfo,
    albumInfo,
    imgInfo
  },
  data () {
    return {
      activeName: '1',
      isDetail: false,
      submitLoading: false,
      backgroundCategoryId: ''
    }
  },
  methods: {
    async handleClick () {
    },
    clickCancel () {
      this.$emit('cancel')
    },
    async validateForm () {
      let step = '1'
      try {
        step = '1'
        await this.$refs.defaultInfo.validateForm()
        // step = '2'
        // await this.$refs.categoryInfo.validateForm()
        step = '3'
        await this.$refs.albumInfo.validateForm()
        step = '4'
        await this.$refs.imgInfo.validateForm()
        return true
      } catch (error) {
        this.activeName = step
        this.$message.error(error.message)
        throw new Error()
      }
    },
    init (node) {
      this.backgroundCategoryId = node.backgroundCategoryId
      this.$refs.defaultInfo.init(node)
      this.$refs.categoryInfo.init(node)
      // this.$refs.albumInfo.init(node)
      // this.$refs.imgInfo.init(node)
    },
    getDataForm () {
      let params = {
        ...this.$refs.defaultInfo.getDataForm(),
        companyId: this.$store.state.user.defaultCompanyId,
        backgroundCategoryId: this.backgroundCategoryId
      }
      params.lclbOssRelation = this.$refs.albumInfo.getDataForm()
      params.remark = this.$refs.imgInfo.getDataForm()
      params.categoryList = this.$refs.categoryInfo.getDataForm()
      return params
    },
    setDataForm (data) {
      this.isDetail = data.isDetail
      this.$refs.defaultInfo.setDataForm(data)
      this.$refs.categoryInfo.setDataForm(data)
      this.$refs.albumInfo.setDataForm(data)
      this.$refs.imgInfo.setDataForm(data)
    },
    resetDataForm () {
      this.isDetail = false
      this.activeName = '1'
      this.$refs.defaultInfo.resetDataForm()
      this.$refs.categoryInfo.resetDataForm()
      this.$refs.albumInfo.resetDataForm()
      this.$refs.imgInfo.resetDataForm()
    },
    async clickSubmit () {
      try {
        await this.validateForm()
        let params = this.getDataForm()
        this.submitLoading = true
        if (params.sparePartsId) {
          // 编辑
          let { data } = await this.$http.post(`/front/order/lclb/sparePartsShare/update`, params)
          if (data.code === 0) {
            this.$message.success('编辑成功！')
            this.$emit('cancel', true)
          }
        } else {
          let { data } = await this.$http.post(`/front/order/lclb/sparePartsShare/save`, params)
          if (data.code === 0) {
            this.$message.success('保存成功！')
            this.$emit('cancel', true)
          }
        }
        this.submitLoading = false
      } catch (error) {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lianchulianbei {
  background: white;
  padding: 20px;
  padding-top: 5px;
  border-top: 1px solid #ccc;
}
.btns {
  text-align: center;
  margin-top: 20px;
  height: 40px;
  .btn {
    margin-left: 20px;
  }
}
.tab-card {
  margin-top: 5px;
  padding: 20px 30px;
  background: #eeeeee61;
}
.no-events {
  pointer-events: none;
}
.no-events {
  /deep/ .el-input__suffix {
    display: none;
  }
}
</style>
